// Convert 00:15 -> 0.25;
export const formatHourToFloat = (time: string): number => {
  let float = 0;
  const [a, b] = String(time).split(':');
  if (a === '01') float += 1;
  float += Number(b) / 60;
  return float;
};
